export const INSTAGRAM_URL = "https://www.instagram.com/joseluisgarcespoesia";
export const INSTAGRAM_HANDLE = "@joseluisgarcespoesia";
export const WHATSAPP_NUMBER = "593999724466";

export const whatsappLink = (productName) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
        `Hola José Luis, quiero comprar ${productName} de «Versos para llevar». ¿Me cuentas tallas y precio?`
    )}`;

export const whatsappBookLink = (bookTitle) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
        `Hola José Luis, quiero comprar tu libro «${bookTitle}». ¿Me cuentas precio y formas de entrega?`
    )}`;

export const bookColors = {
    instantaneas: "#A63D2E",
    "sonido-natural": "#87680F",
    "mujer-ciudad": "#2E6E6A",
    "tres-guerras": "#6E4A7A",
};

export const merch = [
    {
        id: "camiseta-al-viento",
        name: "Camiseta «Al viento van»",
        color: "Negra",
        verse: "Al viento van todas las palabras; al papel, las justas.",
        note: "Logo Poesía In And Out al frente · verso y bicicleta a la espalda",
        images: [
            { src: "/media/merch-c2.jpg", label: "Frente" },
            { src: "/media/merch-c1.jpg", label: "Espalda" },
        ],
    },
    {
        id: "hoodie-solos",
        name: "Hoodie «Solos»",
        color: "Negro",
        verse: "Porque SOLOS no importa cómo lo leas, siempre será un espejo.",
        note: "Logo Poesía In And Out al frente · verso e ilustración a la espalda",
        images: [
            { src: "/media/merch-hn2.webp", label: "Frente" },
            { src: "/media/merch-hn1.webp", label: "Espalda" },
        ],
    },
    {
        id: "camiseta-casi",
        name: "Camiseta «Casi»",
        color: "Blanca",
        verse: "Casi llegas, casi escapo, casi nos vemos… casi olvidamos.",
        note: "Logo y diente de león al frente · verso y firma a la espalda",
        images: [
            { src: "/media/merch-t1-front.jpg", label: "Frente" },
            { src: "/media/merch-t1-back.jpg", label: "Espalda" },
        ],
    },
    {
        id: "camiseta-sonarte",
        name: "Camiseta «Soñarte»",
        color: "Blanca",
        verse: "Lo mejor de todo es soñarte… ahí te quiero y me quieres.",
        note: "Logo al frente · verso, luna y estrellas a la espalda",
        images: [
            { src: "/media/merch-t2-front.jpg", label: "Frente" },
            { src: "/media/merch-t2-back.jpg", label: "Espalda" },
        ],
    },
    {
        id: "hoodie-blanco",
        name: "Hoodie «Aún hay fotografías»",
        color: "Blanco",
        verse: "Aún hay fotografías que se hacen con palabras.",
        note: "Logo Poesía In And Out al frente · verso, cámara y firma a la espalda",
        images: [
            { src: "/media/merch-hb.webp", label: "Frente" },
            { src: "/media/merch-hb-back.webp", label: "Espalda" },
        ],
    },
];

export const books = [
    {
        id: "instantaneas",
        title: "Instantáneas",
        year: "2012",
        publisher: "Libro de Autor · Quito",
        isbn: "ISBN 978-9942-11-267-5",
        meta: "Ilustraciones de Washington Mosquera",
        previewPoemIds: ["instante-i", "calma", "recordar"],
        cover: "/media/instantaneas-real.webp",
        description:
            "El primer instante: fotografías hechas con palabras. Amor, ausencia y memoria en versos que detienen el tiempo.",
        partialIndex: false,
        contra: {
            label: "Epígrafe",
            quote: "Quién hubiera dicho que estos poemas de otros iban a ser míos…",
            author: "Mario Benedetti, «Como árboles»",
        },
        index: [
            "Instante I", "Calma", "Flores de marfil", "Te-me", "Endless",
            "Aire sur", "Espacios", "Instante II", "Ansias", "Somos",
            "Corajudo", "Instante III", "Desahucio", "Epifanía", "Retazos",
            "Instante IV", "Amor es", "Un, dos, tres", "Instante V", "Cabalgata",
            "Sadness", "Instante VI", "Femme", "Lacrimosa", "Inciso",
            "Papiro", "Instante VII", "¿Escuchas?", "Resígnate", "Recordar",
        ],
    },
    {
        id: "sonido-natural",
        title: "Sonido natural",
        year: "2013",
        publisher: "Libro de Autor · Quito",
        isbn: "ISBN 978-9942-13-313-7",
        meta: "Con texto de contraportada de Diego Alejandro Jaramillo",
        previewPoemIds: ["espejo", "sin-tocar", "arritmia"],
        cover: "/covers/sonido.png",
        description:
            "«El desparpajo de la tristeza cotidiana se va perdiendo en un horizonte…». Un segundo libro que invita a paladear los versos, a quedarse en ellos para siempre.",
        partialIndex: false,
        contra: {
            label: "De la contraportada",
            quote: "El poeta, trashumante de las imágenes, se desdibujaría con un Sonido natural, a través de las palabras simples; el desparpajo de la tristeza cotidiana se va perdiendo en un horizonte, donde a veces parpadea una mujer, otras se siente el peso de la soledad, el anhelo de la muerte y el desamor que cuelga de la cuerda floja como un saltimbanqui equilibrista. José Luis Garcés Maldonado sorprende con este segundo libro que invita a paladear los versos, a quedarse en ellos para siempre.",
            author: "Diego Alejandro Jaramillo",
        },
        index: [
            "Espejo", "Agazapada", "Arritmia", "Verte otra vez",
            "Si gritas tu historia", "A punto", "A salvo", "Pintado",
            "Trémulo", "Amantes", "A pesar", "Sin tocar", "Celofán",
            "Azulado", "Bifurcaciones", "A tientas", "Sonámbulos", "Dudas",
            "Viviendo ando", "Alegría", "El pan de la vida", "Marea",
        ],
    },
    {
        id: "mujer-ciudad",
        title: "Mujer Ciudad / Mulher Cidade",
        year: "2016",
        publisher: "Ianua Editora · Quito – Aveiro (Portugal)",
        isbn: "ISBN 978-9942-14-705-9",
        meta: "Edición bilingüe español–portugués · Prólogo de Xavier Oquendo",
        spotify: "1dve92cCVC0kUxbwgVhQa2",
        spotifyAlbum: "1bS6hm2lP8dhDb81tOqRGp",
        previewPoemIds: ["si-aun-te-escribo", "llueve", "casi"],
        cover: "/covers/mujer.png",
        description:
            "Un canto al desamor en clave urbana, en dos idiomas. Traducción al portugués de Xavier Frias Conde.",
        partialIndex: true,
        contra: {
            label: "Del prólogo",
            quote: "José Luis Garcés se ha montado firme en este caballo salvaje y bello de la poesía y ya no hay forma de impedir su paso por estos caminos polvorientos de la palabra. Que así sea. Que así nos venga. Leve y tronante, como los días cenizos del invierno.",
            author: "Xavier Oquendo · Quito, julio de 2016",
        },
        index: [
            "Si aún te escribo…", "Desprenderse", "Llueve", "Pálpitos",
            "Opuestos", "Deberías", "Casi",
        ],
    },
    {
        id: "tres-guerras",
        title: "El hombre de las tres guerras",
        year: "2022",
        publisher: "Ianua Editora · Quito",
        isbn: "ISBN 978-9942-42-255-2",
        meta: "Portada de Carolina Vallejo · Poemas con audio en Spotify",
        spotify: "1dve92cCVC0kUxbwgVhQa2",
        spotifyAlbum: "3XwYi76uUUW3ObCzhZBVHA",
        previewPoemIds: ["tu-sabor", "cero-un-minuto", "nuna"],
        cover: "/covers/guerras.png",
        description:
            "Tres guerras, una sola piel: el amor, el desamor y uno mismo. Varios poemas incluyen audio en Spotify.",
        partialIndex: true,
        contra: {
            label: "Epígrafe",
            quote: "Finalmente la poesía es una religión (sin dios, por si acaso)",
            author: "El hombre de las tres guerras, 2022",
        },
        index: [
            "Tu sabor", "Fue", "0:01", "Fortunita", "Quien dice…",
            "Escápate", "Entre orillas", "La persiana", "De querer", "Late", "Nuna",
        ],
    },
];

export const poems = [
    {
        id: "instante-i",
        title: "Instante I",
        book: "Instantáneas",
        bookId: "instantaneas",
        year: "2012",
        lines: ["Aún hay fotografías", "que se hacen con palabras."],
    },
    {
        id: "calma",
        title: "Calma",
        book: "Instantáneas",
        bookId: "instantaneas",
        year: "2012",
        lines: [
            "Te busco de manera urgente,",
            "como un niño de tres años",
            "perdido",
            "silente.",
            "",
            "Te busco de manera elemental,",
            "y a veces te he confundido",
            "con otros rostros, otras manos, otro lugar.",
            "",
            "Y te encuentro,",
            "te encuentro",
            "tan fácilmente",
            "y de nuevo busco la forma de no perderte.",
        ],
    },
    {
        id: "te-me",
        title: "Te-me",
        book: "Instantáneas",
        bookId: "instantaneas",
        year: "2012",
        lines: [
            "Más que buscarte,",
            "fue encontrarme;",
            "y entre uno y otro,",
            "fue conocerte.",
            "",
            "De tanto conocerte,",
            "llegué a entenderme,",
            "pues entre uno y otro,",
            "solo quería",
            "quererte.",
        ],
    },
    {
        id: "recordar",
        title: "Recordar",
        book: "Instantáneas",
        bookId: "instantaneas",
        year: "2012",
        lines: [
            "Te quiero recordar que aún te recuerdo",
            "no con ansia loca ni odio de víscera",
            "sino en un sepia profundo que enmarca el alma.",
            "",
            "Te quiero recordar que aún te recuerdo",
            "como un trazo delgado y pálido,",
            "leve entre mar y cielo.",
            "",
            "Te recuerdo como risa, como descarga",
            "impulso para asolear mi calma.",
            "",
            "Te quiero recordar que aún te recuerdo",
            "en domingos y feriados",
            "cuando la vida no agobia,",
            "en esas pausas de la memoria.",
            "",
            "Te quiero recordar que aún te recuerdo",
            "no con ansia loca ni odio de víscera",
            "sino tan solo te quería recordar... que aún te recuerdo.",
        ],
    },
    {
        id: "espejo",
        title: "Espejo",
        book: "Sonido natural",
        bookId: "sonido-natural",
        year: "2013",
        lines: [
            "Solo",
            "solo de mí.",
            "",
            "Esperando tu arribo",
            "inconcluso",
            "de incertidumbre",
            "",
            "A ver si arrastras mi esencia",
            "a ver si llegas.",
            "",
            "A ver si despiertas",
            "si concluyes",
            "si renazco.",
            "",
            "Solo",
            "solo de mí",
            "solo si vuelves.",
            "",
            "A ver si regreso",
            "a ver si llegas.",
        ],
    },
    {
        id: "sin-tocar",
        title: "Sin tocar",
        book: "Sonido natural",
        bookId: "sonido-natural",
        year: "2013",
        lines: [
            "Una mirada carga alma.",
            "Lo que callamos somos",
            "el sonido de lo natural.",
            "",
            "El compás de los cuerpos",
            "encaja sin conjuros",
            "en la cadencia de la vida.",
            "",
            "Somos ritmo puro",
            "de un encanto por buscar.",
        ],
    },
    {
        id: "arritmia",
        title: "Arritmia",
        book: "Sonido natural",
        bookId: "sonido-natural",
        year: "2013",
        lines: [
            "No hay más lazo",
            "que mis ganas y tu angustia.",
            "No hay más esencia",
            "que tu silencio y mi entrega,",
            "tu duda y mi cariño.",
            "",
            "Nos une un destino",
            "de placer y fastidio",
            "un extraño calor.",
            "",
            "¿Dejo que te vayas",
            "o te quedes?",
            "¿Te escapas o ya",
            "vuelves?",
        ],
    },
    {
        id: "verte-otra-vez",
        title: "Verte otra vez",
        book: "Sonido natural",
        bookId: "sonido-natural",
        year: "2013",
        lines: [
            "Si viento fueras",
            "pasajera",
            "en mi alma de hoja andarías",
            "volátil madurez.",
            "",
            "Si sueño fueras",
            "silencio",
            "en mi deseo escondido encontrarías",
            "el dormir en tu revés.",
            "",
            "Si tan solo fueras",
            "no se desgastaría",
            "mi ansia de no verte",
            "por verte otra vez.",
        ],
    },
    {
        id: "tremulo",
        title: "Trémulo",
        book: "Sonido natural",
        bookId: "sonido-natural",
        year: "2013",
        videoId: "poema-0126",
        lines: [
            "El amor represado",
            "se desborda",
            "o se hastía.",
            "",
            "Si se desborda arrasa",
            "sin filtro sin freno sin paz.",
            "",
            "Si se hastía mata y muere",
            "corroe y calcina.",
            "Silencio y ansiedad.",
        ],
    },
    {
        id: "si-aun-te-escribo",
        title: "Si aún te escribo…",
        book: "Mujer Ciudad",
        bookId: "mujer-ciudad",
        year: "2016",
        lines: [
            "Si aún te escribo…",
            "no llegaste",
            "y abuso de tu recuerdo",
            "y sacudo mi locura",
            "(destierro)",
            "en esta patria de papel",
        ],
    },
    {
        id: "desprenderse",
        title: "Desprenderse",
        book: "Mujer Ciudad",
        bookId: "mujer-ciudad",
        year: "2016",
        videoId: "desprenderse",
        lines: [
            "Este adiós resguardado que me aqueja",
            "no lo suelto a sus anchas y albedrío.",
            "No por temor a perderte en la fuga",
            "en realidad",
            "ya te fuiste.",
            "",
            "Lo hago",
            "porque entre la tristeza y la nostalgia",
            "hay un espacio tan duro tan vacío",
            "que cuando pueda recordarte",
            "en paz… con calma",
            "seguramente",
            "seremos desconocidos",
        ],
    },
    {
        id: "llueve",
        title: "Llueve",
        book: "Mujer Ciudad",
        bookId: "mujer-ciudad",
        year: "2016",
        spotifyTrack: "1oMz9Ds5dmSrSwQJCicbAo",
        lines: [
            "A cántaros,",
            "llueve a cántaros.",
            "Sin viento, sin pausa, sin azul",
            "",
            "Repite la gota en la cabeza",
            "su estruendo al caer",
            "y resbala como caricia",
            "en párpados, mejillas y boca",
            "",
            "A cántaros,",
            "llueve a cántaros",
            "en monzón… para creer",
        ],
    },
    {
        id: "deberias",
        title: "Deberías",
        book: "Mujer Ciudad",
        bookId: "mujer-ciudad",
        year: "2016",
        lines: [
            "Te deberías olvidar de mí",
            "empujando mi cobardía",
            "arrastrando mis adentros",
            "a ver si vuelvo",
            "me rescato",
            "",
            "Te deberías olvidar de mí",
            "como lo haces por periodos",
            "donde sobrevivo",
            "con la ansiedad pausada",
            "y el vilo en resguardo",
            "",
            "Te deberías olvidar de mí",
            "por piedad, por hartazgo",
            "permitir desgraciarme",
            "una sola vez",
            "continua y profunda",
            "pero olvidar",
            "",
            "No parpadear lejana y ajena",
            "como aire cálido y canela",
        ],
    },
    {
        id: "casi",
        title: "Casi",
        book: "Mujer Ciudad",
        bookId: "mujer-ciudad",
        year: "2016",
        spotifyTrack: "4ALoxbXKZJngAEH7yl9iS6",
        lines: [
            "Casi te quiero",
            "casi me quieres",
            "casi nos sentamos juntos y no de frente",
            "casi planeamos locuras y me robas un beso",
            "casi eres lluvia y yo cántaro",
            "",
            "Casi nos encontramos sin pretexto",
            "siendo complemento",
            "casi me miras entre canciones",
            "casi dejas de ser verso",
            "",
            "Casi llegas",
            "casi escapo",
            "",
            "Casi nos vemos",
            "casi…",
            "casi olvidamos",
        ],
    },
    {
        id: "tu-sabor",
        title: "Tu sabor",
        book: "El hombre de las tres guerras",
        bookId: "tres-guerras",
        year: "2022",
        spotifyTrack: "60hItGVHCB03FP7W8A7RTQ",
        lines: [
            "Me gusta tu sabor a chocolate",
            "tu aroma como a café",
            "tu piel de helado en la tarde",
            "tus tristezas sin ayer.",
            "",
            "Me gusta tu alma gitana",
            "que se esparce por el mundo",
            "y tu alegría liviana",
            "que se pega como fe.",
            "",
            "Me gusta el tiempo en que no fuiste",
            "y este tiempo en que no sé…",
            "me gusta cabildear con la utopía",
            "no digas nada todavía,",
            "me gusta moverme en tu piel.",
        ],
    },
    {
        id: "cero-un-minuto",
        title: "0:01",
        book: "El hombre de las tres guerras",
        bookId: "tres-guerras",
        year: "2022",
        spotifyTrack: "60D4AikCbvP2X8cBkUHBj1",
        lines: [
            "Le guardo siempre un minuto",
            "reservado para su uso exclusivo",
            "un minuto que se reclama",
            "con derecho y furia",
            "en tempestad o armonía.",
            "",
            "¿Un minuto?",
            "me preguntan los incrédulos",
            "me miran como egoísta",
            "¿solo un minuto?",
            "",
            "Porque en un minuto",
            "cabe un beso largo",
            "una caricia de pies a manos",
            "un abrazo de ojos cerrados",
            "una mirada sentida.",
            "",
            "Porque en un minuto",
            "nacemos, morimos",
            "contemplamos",
            "somos los que no fuimos un día.",
        ],
    },
    {
        id: "escapate",
        title: "Escápate",
        book: "El hombre de las tres guerras",
        bookId: "tres-guerras",
        year: "2022",
        lines: [
            "Escápate del espejo de voces desfigurantes",
            "y acoge la soledad en tu sonido",
            "huye de inmediato de tus ropas y harapos",
            "y descubre desnudos tus pies... tu latido.",
            "",
            "Escápate y arrastra mi sangre",
            "quizás sean tus venas el caudal escondido",
            "escápate… te espero en mi vera",
            "dame el valor de perder lo perdido.",
            "",
            "Escápate, escápanos",
            "conquistemos la hoguera",
            "fundamos a lava",
            "el hierro que fuimos.",
        ],
    },
    {
        id: "nuna",
        title: "Nuna",
        book: "El hombre de las tres guerras",
        bookId: "tres-guerras",
        year: "2022",
        spotifyTrack: "6NgV0HLvEFFJXPFvcZkroV",
        videoId: "nuna",
        lines: [
            "¿Tendrás entendimiento, andina",
            "de la ansiedad de tus pajonales",
            "y el fértil poder de tu viento?",
            "",
            "Cuando ando, andina",
            "en tus cumbres paralelas",
            "y tus vastos humedales",
            "a paso tendido",
            "he tenido, andina",
            "reveladoras epifanías",
            "y azules soledades.",
            "",
            "¿Tendrás en cuenta, serrana",
            "tu cercanía al cielo",
            "y en tan corta estatura",
            "el poder inmenso",
            "de tu sol cenital?",
            "",
            "Cuando hablo, serrana",
            "con tu páramo sabio",
            "y recorro a caballo",
            "tu ladera invernal.",
            "He tenido, serrana",
            "el grito de los sueños",
            "y la paz sin edad.",
            "",
            "¿Sabrás, nuna",
            "de tus ocres y verdes",
            "de esa alfombra eterna",
            "que adorna tu plenitud?",
            "",
            "Cuando te veo, nuna",
            "con tus bordes y pliegues",
            "en tu cráter nevado",
            "y te comienzo a escalar…",
            "he vivido, nuna",
            "con tu paisaje desde siempre",
            "y con el borde de mis dedos",
            "te he soñado pintar.",
        ],
    },
];

export const collagePhotos = [
    {
        src: "/media/merch-puesta-2.jpg",
        caption: "Camiseta «Casi» — al frente",
        alt: "Persona vistiendo la camiseta Poesía In And Out con flores secas",
    },
    {
        src: "/media/merch-puesta-1.webp",
        caption: "Camiseta «Casi» — a la espalda",
        alt: "Espalda de la camiseta Casi puesta: casi llegas, casi escapo, casi nos vemos, casi olvidamos",
    },
    {
        src: "/media/merch-puesta-4.webp",
        caption: "Camiseta «Soñarte» — en la azotea",
        alt: "Espalda de la camiseta Soñarte puesta, mirando la ciudad desde una azotea",
    },
    {
        src: "/media/merch-puesta-3.webp",
        caption: "Hoodie «Aún hay fotografías» — al frente",
        alt: "José Luis Garcés Maldonado vistiendo el hoodie blanco Poesía In And Out",
    },
];

export const marqueeVerses = [
    "Aún hay fotografías que se hacen con palabras",
    "El sueño es el lugar donde la realidad se vuelve poesía",
    "Lo que callamos somos, el sonido de lo natural",
    "En el horizonte siempre se unen lo que pisamos y lo que soñamos",
    "La palabra contiene el tiempo, fotografía del pensamiento",
    "Entre el amor y el silencio hay dos distancias",
    "Me gustan esas revoluciones que son contra uno mismo",
    "Finalmente la poesía es una religión (sin dios, por si acaso)",
];

export const chapters = [
    {
        numeral: "I",
        title: "El origen",
        kicker: "Quito, 1982",
        text: "Comunicador de profesión (Licenciado en Comunicación por la Universidad Católica de Quito y Máster en Comunicación Política e Institucional por el Instituto Ortega y Gasset, Argentina) y poeta por vocación. Docente universitario, consultor y ganador de dos concursos juveniles de poesía.",
        photo: {
            src: "/media/h2.webp",
            caption: "Quito, años ochenta",
            alt: "José Luis Garcés Maldonado de niño",
        },
    },
    {
        numeral: "II",
        title: "La palabra impresa",
        kicker: "2012 — 2022",
        text: "Los libros: Instantáneas (2012), Sonido natural (2013), Mujer Ciudad / Mulher Cidade (2016, edición bilingüe español–portugués) y El hombre de las tres guerras (2022), este último con poemas que también se escuchan en Spotify.",
        photo: {
            src: "/media/h3.webp",
            caption: "Lanzamiento de Mujer Ciudad, 2016",
            alt: "Celebración del lanzamiento de Mujer Ciudad con amigos",
        },
    },
    {
        numeral: "III",
        title: "La imagen en movimiento",
        kicker: "Vídeo poesía",
        text: "La poesía no se quedó en el papel. En Instagram, los versos se convierten en vídeo poesía: voz, imagen y ritmo para una nueva forma de leer. Cada creación es un poema que también se mira y se escucha.",
        photo: {
            src: "/media/h1.webp",
            caption: "La poesía también se juega",
            alt: "José Luis Garcés Maldonado junto a una escultura",
            pos: "object-right",
        },
    },
];

export const videoPoems = [
    {
        id: "treinta",
        title: "¿Qué es Poesía In and Out?",
        book: "",
        src: "/media/vp-treinta.mp4",
        poster: "/media/vp-treinta.jpg",
    },
    {
        id: "resignate",
        title: "Resígnate",
        book: "Instantáneas · 2012",
        src: "/media/vp-resignate.mp4",
        poster: "/media/vp-resignate.jpg",
    },
    {
        id: "opuestos",
        title: "Opuestos",
        book: "Mujer Ciudad · 2016",
        src: "/media/vp-opuestos.mp4",
        poster: "/media/vp-opuestos.jpg",
    },
    {
        id: "desprenderse",
        title: "Desprenderse",
        book: "Mujer Ciudad · 2016",
        src: "/media/vp-desprenderse.mp4",
        poster: "/media/vp-desprenderse.jpg",
    },
    {
        id: "distintos",
        title: "Distintos",
        book: "Inédito",
        src: "/media/vp-distintos.mp4",
        poster: "/media/vp-distintos.jpg",
    },
    {
        id: "poema-0126",
        title: "Trémulo",
        book: "Sonido natural · 2013",
        src: "/media/vp-img0126.mp4",
        poster: "/media/vp-img0126.jpg",
    },
    {
        id: "nuna",
        title: "Nuna",
        book: "El hombre de las tres guerras · 2022",
        src: "/media/vp-nuna.mp4",
        poster: "/media/vp-nuna.jpg",
    },
    {
        id: "aires-sur",
        title: "Aires Sur",
        book: "Instantáneas · 2012",
        src: "/media/vp-aires-sur.mp4",
        poster: "/media/vp-aires-sur.jpg",
    },
];

export const songs = [
    {
        id: "nuna",
        title: "Nuna",
        note: "Poema «Nuna» · El hombre de las tres guerras",
        src: "/media/song-nuna.mp3",
        poemId: "nuna",
    },
    {
        id: "tu-sabor",
        title: "Tu sabor",
        note: "Poema «Tu sabor» · El hombre de las tres guerras",
        src: "/media/song-tu-sabor.mp3",
        poemId: "tu-sabor",
    },
    {
        id: "arrepentirme-no",
        title: "Arrepentirme No",
        note: "Poema inédito",
        src: "/media/song-arrepentirme-no.mp3",
    },
    {
        id: "calma",
        title: "Calma",
        note: "Poema «Calma» · Instantáneas",
        src: "/media/song-calma.mp3",
        poemId: "calma",
    },
    {
        id: "distopia",
        title: "Distopía",
        note: "Poema inédito",
        src: "/media/song-distopia.mp3",
    },
    {
        id: "recordar",
        title: "Recordar",
        note: "Poema «Recordar» · Instantáneas",
        src: "/media/song-recordar.mp3",
        poemId: "recordar",
    },
];
